(ns ui.dall-e.page
  "Dall-E Page"
  (:require [ui.app-frame :as app-frame]))

(defn render [state]
  (app-frame/app-frame
    state
    [:div
     [:button
      {:on {:click [[:ui/modal-open
                     :modals/openai-image-generation-modal
                     {} ;; params map
                     ]]}}
      "open modal"]]))

(def page
  {:page-id :pages/openai-image-generation
   :route [["ui" "image-generation" "openai"]]
   :render #'render})

